import React, { useCallback, useRef } from 'react'

import Intro from 'components/slices/Intro'
import Layout from 'components/shared/Layout'
import NewsletterBanner from 'components/slices/NewsletterBanner'

import useAnimateInView from 'hooks/useAnimateInView'
import useTimeline from 'hooks/useTimeline'

import Position from './Position'
import css from './styles.module.scss'

const CareersPositions = ({ intro, positions = [], form }) => {
  const animatables = useRef([])
  const registerRef = useCallback((node) => {
    if (!node) return
    animatables.current = animatables.current.concat(node)
  }, [])
  const showTl = useTimeline({ paused: true, delay: 0.5 }, (tl) => {
    tl.fromTo(
      animatables.current,
      {
        z: -100,
        autoAlpha: 0,
      },
      {
        z: 0,
        autoAlpha: 1,
        transformPerspective: 500,
        duration: 0.4,
        stagger: 0.08,
        delay: 0.1,
        force3D: true,
        ease: 'elastic.out(0.3, 0.4)',
      }
    )
  })

  const [inViewRef] = useAnimateInView({
    triggerOnce: true,
    threshold: 0.2,
    animateIn: () => showTl.restart(true),
  })

  return (
    <Layout type="fullWidth" className={css.backgroundWrapper}>
      {intro && <Intro {...intro} />}

      <div ref={inViewRef}>
        <Layout type="wrapper" className={css.wrapper}>
          {positions &&
            positions.map((position, key) => (
              <Position
                {...position}
                key={`position-${key}`}
                forwardref={registerRef}
              />
            ))}
        </Layout>
      </div>

      <NewsletterBanner newsletter={form} layout="vertical" />
    </Layout>
  )
}

CareersPositions.defaultProps = {}

export default CareersPositions
